// extracted by mini-css-extract-plugin
export default {"home":"c-i_cT","home__background":"c-i_cU","home__content":"c-i_cV"};